<template>
    <div>
        <div id="mapdiv" :class="{'repeater-mapdiv': userAction !== 'newregistration'}"></div>
        <div class="info-box-map" v-if="showInfoMap">
          <p>Angiv position ved at trække i kortet</p>
          <div @click="setShowInfoMap(false)">
            <icon class="small-svg" name="remove"></icon>
          </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";

export default {
  name: "map-component",
  props: ["modalComponent", "pos", "userAction"],
  data() {
    return {
      data: {
        id: undefined,
        layers: []
      },
      map: undefined,
      layerControl: undefined,
      wmsLayers: [],
      backgroundLayers: {},
      overlays: {},
      layers: {},
      layerConfigs: [],
      options: {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      activeFormId: "getActiveFormId",
      getPosition: "getPosition",
      showInfoMap: "getShowInfoMap"
    })
  },
  methods: {
    ...mapActions({
      savePosition: "savePosition",
      getMapLayers: "getMapLayers",
      setShowInfoMap: "setShowInfoMap",
      savePositionOnRepeater: "savePositionOnRepeater"
    }),
    init() {
      const _this = this;
      let crs = new window["L"].Proj.CRS(
        "EPSG:25832",
        "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs",
        {
          resolutions: [
            1638.4,
            819.2,
            409.6,
            204.8,
            102.4,
            51.2,
            25.6,
            12.8,
            6.4,
            3.2,
            1.6,
            0.8,
            0.4,
            0.2,
            0.1
          ],
          origin: [120000.0, 6500000.0],
          bounds: window["L"].bounds(
            [120000.0, 6500000.0],
            [1000000.0, 5900000.0]
          )
        }
      );

      // initialize map
      _this.map = _this.initMap(crs);
      let mapAttribution =
        '&copy; <a target="_blank" href="https://datafordeler.dk/vejledning/brugervilkaar/sdfe-geografiske-data/">SDFE - Geografiske data</a>';

      var basemaps = {
        "Orto forår": L.tileLayer.wms('https://services.datafordeler.dk/GeoDanmarkOrto/orto_foraar/1.0.0/Wms', {
            layers: 'geodanmark_2021_12_5cm',
            username: "BIOAJOFBEQ",
            password: "Niras-001",
            format: "image/jpeg",
            version: "1.3.0",
            transparent: "FALSE",
            attribution: mapAttribution
        }),

        "Skærmkort dæmpet": L.tileLayer.wms('https://services.datafordeler.dk/Dkskaermkort/topo_skaermkort/1.0.0/wms', {
            layers: 'DTK_skaermkort_daempet',
            username: "BIOAJOFBEQ",
            password: "Niras-001",
            format: "image/jpeg",
            version: "1.3.0",
            transparent: "FALSE",
            attribution: mapAttribution
        })
      };

      window["L"].control.layers(basemaps).addTo(_this.map);

      basemaps["Orto forår"].addTo(_this.map);

      // let wms2 = window["L"].tileLayer
      //   .wms("https://services.kortforsyningen.dk/orto_foraar", {
      //     layers: "orto_foraar",
      //     login: "smartinspect",
      //     password: "malawi77",
      //     format: "image/jpeg",
      //     attribution: mapAttribution
      //   })
      

      _this
        .initDisplayLayers(_this.map, _this.backgroundLayers, _this.overlays)
        .then(() => {
          // _this.layerControl = window["L"].control
            // .layers(_this.backgroundLayers, _this.overlays)
            // .addTo(_this.map);
        });
    },
    initMap(crs) {
      const _this = this;
      let mymap = window["L"]
        .map("mapdiv", { crs: crs })
        .setView([57.047218, 9.9201], 11);
      // let wms = window["L"].tileLayer
      //   .wms("https://services.kortforsyningen.dk/orto_foraar", {
      //     layers: "orto_foraar",
      //     login: "smartinspect",
      //     password: "malawi77",
      //     format: "image/jpeg",
      //     attribution: mapAttribution
      //   })
      //   .addTo(mymap);

      window["L"].control.mapCenterCoord().addTo(mymap);
      mymap.on("moveend", _this.updateCoords);

      mymap.invalidateSize();
      if (!_this.pos && _this.getPosition && _this.getPosition.coordinates) {
        let object = {
          lng: _this.getPosition.coordinates[0],
          lat: _this.getPosition.coordinates[1]
        };
        mymap.setView([object.lat, object.lng]);
      } else if (!_this.pos) {
        window.navigator.geolocation.getCurrentPosition(
          function(pos) {
            if (_this.modalComponent) {
              _this.savePositionOnRepeater(pos);
            } else {
              _this.savePosition(pos);
            }
            mymap.setView([pos.coords.latitude, pos.coords.longitude]);
          },
          _this.error,
          _this.options
        );
      } else {
        if (_this.pos.location) {
          let object = {
            lng: _this.pos.location.coordinates[0],
            lat: _this.pos.location.coordinates[1]
          };
          mymap.setView([object.lat, object.lng]);
        } else {
          window.navigator.geolocation.getCurrentPosition(
            function(pos) {
              if (_this.modalComponent) {
                _this.savePositionOnRepeater(pos);
              } else {
                _this.savePosition(pos);
              }
              mymap.setView([pos.coords.latitude, pos.coords.longitude]);
            },
            _this.error,
            _this.options
          );
        }
      }
      return mymap;
    },
    initDisplayLayers(map, backgroundLayers, overlays) {
      const _this = this;

      return _this.getMapLayers((item, key, idx) => {
        if (item.type === "raster") {
          let layer = null;

          if (item.offlineLayer) {
            layer = window["L"].tileLayer.cached(item.url, {
              attribution: "Geodatastyrelsen",
              maxNativeZoom: 11,
              maxZoom: 14,
              minZoom: 0,
              title: item.layerName
            });
          } else {
            layer = window["L"]
              .tileLayer(item.url, {
                attribution: "Geodatastyrelsen",
                maxZoom: 13,
                minZoom: 0,
                title: item.layerName
              })
              .addTo(map);
          }

          if (item.isOverlay) {
            overlays[item.layerName] = layer;
          } else {
            backgroundLayers[item.layerName] = layer;
          }
        }
      });
    },
    error(err) {
      console.warn("ERROR " + err.code + " : " + err.message);
    },
    success(pos) {
      var crd = pos.coords;
      console.log("Your current position is:");
      console.log("coords :" + crd.latitude + " " + crd.longitude);
    },
    onMapClick(e) {
      const _this = this;
      let newMarker = new window["L"].Marker(e.latlng).addTo(_this.map);
      console.log(newMarker);
    },
    updateCoords(e) {
      const _this = this;
      let position = e.target;
      let coords = position.getCenter();
      if (_this.modalComponent) {
        _this.savePositionOnRepeater(coords);
      } else {
        _this.savePosition(coords);
      }
    }
  },
  beforeDestroy() {
    let _this = this;

    for (let layer in _this.overlays) {
      if (_this.overlays[layer].clearLayers !== undefined) {
        _this.overlays[layer].clearLayers();
      }

      _this.map.removeLayer(_this.overlays[layer]);
      _this.layerControl.removeLayer(_this.overlays[layer]);
    }

    for (var layer in _this.layers) {
      _this.layerControl.removeLayer(_this.layers[layer]);
    }

    _this.map.eachLayer(function(layer) {
      _this.map.removeLayer(layer);
    });

    _this.overlays = undefined;
    _this.layers = undefined;
    _this.map.remove();
    _this.map.off();
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
/* eslint-disable */
#mapdiv {
  height: calc(100vh - 64px - 61px);
  width: 100%;
  position: absolute;
  top: 60px;
  bottom: 0px;
  left: 0;
  right: 0;
  z-index: 99;
}

.map-body #mapdiv {
  top: 92px !important;
}

.repeater-mapdiv {
  height: calc(100vh - 64px - 25px) !important;
}
</style>
